import {NavbarModule}     from "./navbar/navbar";
import {SidebarModule}    from "./sidebar/sidebar";

export const LayoutModule = angular
	.module("layout", [
		NavbarModule.name,
		SidebarModule.name
	]);


// WEBPACK FOOTER //
// ./sources/components/layout/layout.js